import type {
  SupplierQuotationUnitType,
  UpdateSupplierQuotationItemPayload,
} from "@/features/supplierQuotation/types";
import {
  getQuotationPriceInputLabel,
  isDirectKgUnit,
  usesKgPerBox,
  usesUnitsPerBox,
} from "@/features/quotation/unitLabels";

function parsePositiveNumber(value: string) {
  const parsed = Number(value.replace(",", "."));
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
}

type BuildSupplierItemPayloadParams = {
  unitType: SupplierQuotationUnitType;
  pricePerBox: number | null;
  pricePerKg: number | null;
  unitsPerBox: string;
  kgPerBox: string;
};

type BuildSupplierItemPayloadResult =
  | {
      payload: UpdateSupplierQuotationItemPayload;
      error: null;
    }
  | {
      payload: null;
      error: string;
    };

export function buildSupplierItemPayload(
  params: BuildSupplierItemPayloadParams,
): BuildSupplierItemPayloadResult {
  const { unitType, pricePerBox, pricePerKg, unitsPerBox, kgPerBox } = params;

  const payload: UpdateSupplierQuotationItemPayload = {
    unit_type: unitType,
  };

  if (isDirectKgUnit(unitType)) {
    if (!pricePerKg) {
      return {
        payload: null,
        error: "Informe um preço por kg válido.",
      };
    }
    payload.price_per_kg = pricePerKg;
  } else {
    if (!pricePerBox) {
      return {
        payload: null,
        error: `Informe ${getQuotationPriceInputLabel(unitType).toLowerCase()} válido.`,
      };
    }
    payload.price_per_box = pricePerBox;
  }

  if (usesUnitsPerBox(unitType)) {
    const parsedUnitsPerBox = parsePositiveNumber(unitsPerBox);
    if (!parsedUnitsPerBox) {
      return {
        payload: null,
        error: "Informe quantas unidades existem por caixa.",
      };
    }
    payload.units_per_box = parsedUnitsPerBox;
  }

  if (usesKgPerBox(unitType)) {
    const parsedKgPerBox = parsePositiveNumber(kgPerBox);
    if (!parsedKgPerBox) {
      return {
        payload: null,
        error: "Informe o peso por caixa ou saco.",
      };
    }
    payload.kg_per_box = parsedKgPerBox;
  }

  return { payload, error: null };
}
